<script>
import { addFlow, addFlowTrigger, getSegments } from "@/api/campaigns.js";
import Multiselect from "vue-multiselect";
import moment from "moment";
import swal from "sweetalert";
import { Datetime } from "vue-datetime";
export default {
  name: "add-campaign-flow-modal",
  components: {
    Multiselect,
    datetime: Datetime,
  },
  data() {
    return {
      form: {
        name: "",
      },
      item: null,
      title: "Add Campaign Flow",
      spinning: false,
      segment: null,
      segments: [],
      workflow_trigger: [
        {
          id: 0,
          name: "When someone joins a segment",
          type: "CAMPAIGN_FLOW_TRIGGER_SOMEONE_JOINS_SEGMENT",
          desc:
            "*Flow triggered when a subscriber joins your segment.User choose segment from dropdown, complete with search function.",
        },
        {
          id: 1,
          name: "When subscriber clicks a link",
          type: "CAMPAIGN_FLOW_TRIGGER_CLICKS_A_LINK",
          desc: "",
        },
        {
          id: 2,
          name: "Updated field",
          type: "CAMPAIGN_FLOW_TRIGGER_UPDATED_FIELD",
          desc:
            "*Flow triggered when a subscriber field is updated. Field list appears with search. List of fields:",
        },
        {
          id: 3,
          name: "Anniversary of a date",
          type: "CAMPAIGN_FLOW_TRIGGER_ANNIVERSARY_OF_DATE",
          desc:
            "*Flow triggered every year on specific dates (great for birthdays, wedding anniversary, etc.).User chooses segment. User then chooses option of 'on' or 'before' from dropdown.If before, user is given option to choose minutes, hours, days, weeks, months.Then user selects the date field (options are: birthday, anniversary, date of first visit) to apply it to.",
        },
      ],
      updated_field: [
        { id: 0, name: "Email" },
        { id: 1, name: "Fist Name" },
        { id: 2, name: "Last Name" },
        { id: 3, name: "Phone" },
        { id: 4, name: "Company" },
        { id: 5, name: "Street" },
        { id: 6, name: "City" },
        { id: 7, name: "State" },
        { id: 8, name: "Country" },
        { id: 9, name: "Zip" },
      ],
      date_conditons: [
        { id: 0, name: "On", type: "DATE_ON" },
        { id: 1, name: "Before", type: "DATE_BEFORE" },
      ],
      updatedField: null,
      triggers: null,
      date_condition: null,
      anniv_date: null,
      link: "",
    };
  },
  async mounted() {
    const response = await getSegments();
    if (response) {
      this.segments = response;
      // console.log(this.segments);
    }
  },
  computed: {
    segmentOptions() {
      return [
        ...this.segments.map((item) => {
          return {
            value: item.id,
            text: item.name,
          };
        }),
      ];
    },
    workflowTriggerOptions() {
      return [
        { value: null, text: "Please select", desc: "" },
        ...this.workflow_trigger.map((list) => {
          return {
            value: list.id,
            text: list.name,
            type: list.type,
            desc: list.desc,
          };
        }),
      ];
    },
    updatedFieldsOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.updated_field.map((list) => {
          return {
            value: list.id,
            text: list.name,
          };
        }),
      ];
    },
    dateOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.date_conditons.map((list) => {
          return {
            value: list.id,
            text: list.name,
            type: list.type,
          };
        }),
      ];
    },
  },
  methods: {
    hide() {
      this.spinning = false;
      this.form.name = "";
      this.$store.dispatch("getSubscribersList");
      this.$refs["add-campaign-flow-modal"].hide();
    },
    async onSubmit() {
      this.spinning = true;
      const payload = JSON.parse(JSON.stringify(this.form));
      // console.log(payload);
      // let segment = this.segment;
      // console.log(segment.value);
      const response = await addFlow(payload);
      if (response) {
        this.spinning = false;
        this.form.name = "";
        this.$store.dispatch("getFlows");
        let payload = {};
        if (
          this.triggers.type == "CAMPAIGN_FLOW_TRIGGER_SOMEONE_JOINS_SEGMENT"
        ) {
          payload = {
            trigger_type: this.triggers.type,
            trigger_details: {
              trigger_content_type: "segment",
              trigger_object_id: this.segment.value,
            },
            scheduled_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            initial: true,
            flow: response.id,
            previous_flow_item: null,
          };
        } else if (
          this.triggers.type == "CAMPAIGN_FLOW_TRIGGER_CLICKS_A_LINK"
        ) {
          payload = {
            trigger_type: this.triggers.type,
            trigger_details: {
              url: this.link,
            },
            scheduled_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            initial: true,
            flow: response.id,
            previous_flow_item: null,
          };
        } else if (
          this.triggers.type == "CAMPAIGN_FLOW_TRIGGER_UPDATED_FIELD"
        ) {
          var arr_fields = this.updatedField.map((a) =>
            a.text.toLowerCase().trim()
          );
          payload = {
            trigger_type: this.triggers.type,
            trigger_details: {
              fields: arr_fields,
            },
            scheduled_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            initial: true,
            flow: response.id,
            previous_flow_item: null,
          };
        } else if (
          this.triggers.type == "CAMPAIGN_FLOW_TRIGGER_ANNIVERSARY_OF_DATE"
        ) {
          payload = {
            trigger_type: this.triggers.type,
            trigger_details: {
              trigger_when: this.date_condition.type,
              selected_date: moment(this.anniv_date).format("YYYY-MM-DD"),
            },
            scheduled_date: moment().format("YYYY-MM-DD HH:mm:ss"),
            initial: true,
            flow: response.id,
            previous_flow_item: null,
          };
        }
        const response2 = await addFlowTrigger(payload);
        if (response2) {
          this.$refs["add-campaign-flow-modal"].hide();
          this.$router.push(`/flows/builder/${response.id}`);
        }
      }
    },
  },
};
</script>
<style src="@/assets/css/vue-multiselect.min.css"></style>
<template>
  <b-modal
    id="add-campaign-flow-modal"
    ref="add-campaign-flow-modal"
    :title="title"
    size="sm"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      id="add-subscriber-list-form"
    >
      <b-form-group label="Workflow Name">
        <b-form-input
          id="input-1"
          v-model="form.name"
          type="text"
          required
          placeholder="Enter name"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Workflow Trigger"
        :description="triggers ? triggers.desc : ''"
      >
        <multiselect
          v-model="triggers"
          :options="workflowTriggerOptions"
          label="text"
          track-by="value"
        ></multiselect>
      </b-form-group>
      <b-form-group
        v-if="triggers && triggers.value == 1"
        id="input-group-link"
        label="Link"
        label-for="input-link"
      >
        <b-form-input
          id="input-link"
          v-model="link"
          type="text"
          required
          placeholder="Please input link"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        v-if="triggers && (triggers.value == 0 || triggers.value == 3)"
        label="Segment"
      >
        <multiselect
          v-model="segment"
          :options="segmentOptions"
          label="text"
          track-by="value"
        ></multiselect>
      </b-form-group>
      <b-form-group v-if="triggers && triggers.value == 2" label="Custom Field">
        <multiselect
          v-model="updatedField"
          :options="updatedFieldsOptions"
          label="text"
          track-by="value"
          :multiple="true"
          :taggable="true"
        ></multiselect>
      </b-form-group>
      <div v-if="triggers && triggers.value == 3">
        <b-form-group label="">
          <b-form-select
            v-model="date_condition"
            :options="dateOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Date and Time">
          <datetime
            v-model="anniv_date"
            type="datetime"
            input-class="form-control"
            value-zone="UTC"
            zone="local"
            aria-placeholder="Calendar"
            format="yyyy-MM-dd HH:mm"
          >
            <template slot="button-cancel">
              Cancel
            </template>
            <template slot="button-confirm" slot-scope="scope">
              <span v-if="scope.step === 'date'">Next </span>
              <span v-else>Confirm </span>
            </template>
          </datetime>
        </b-form-group>
      </div>
      <b-button
        type="submit"
        class="float-right"
        variant="primary"
        v-if="!spinning"
      >
        Submit
      </b-button>
      <b-spinner
        v-show="spinning"
        label="Spinning"
        class="float-right"
      ></b-spinner>
    </b-form>
  </b-modal>
</template>
